import { Directive, HostListener, inject } from '@angular/core';
import { Location } from '@angular/common';

@Directive({
    selector: '[skychuteBackButton]',
    standalone: false
})
export class BackButtonDirective {
  private location = inject(Location);


  @HostListener('click')
  onClick(): void {
    this.location.back();
  }
}
